import { MutationTree } from 'vuex';
import { AuthState } from './state';
import { AUTHENTICATION_SET_USER } from './types';

export const mutations: MutationTree<AuthState> = {
  [AUTHENTICATION_SET_USER](state: AuthState, payload: AuthState) {
    state.username = payload.username;
    state.accessToken = payload.accessToken;
    state.isLogged = payload.isLogged;
    state.tokenExpiresDate = payload.tokenExpiresDate;
  },
};
